"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldCleanWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const icons_core_1 = require("@volkswagen-onehub/icons-core");
const React = __importStar(require("react"));
const utils_1 = require("../utils");
const StyledClearButton = components_core_1.styled.button `
  background: transparent;
  padding: 0;
  border: none;
  line-height: 0;
  cursor: pointer;
  color: ${utils_1.getLabelIconColor};
  border-bottom: 1px solid transparent;
  pointer-events: initial;
  :hover {
    color: ${props => props.theme.colors.button.primary.hover};
  }
  :focus {
    color: ${props => props.theme.colors.button.primary.hover};
    ${props => (0, utils_1.createA11yOutlineStyles)(props)}
  }
`;
const StyledClearButtonWrapper = components_core_1.styled.div `
  position: absolute;
  right: 0;
  left: 0;
  bottom: ${props => props.theme.size.static200};
  pointer-events: none;
  display: flex;
  flex-direction: row-reverse;
`;
const TextFieldCleanWrapper = props => {
    const { appearance, children, onClear, clearIconLabel, hasClearButton, isClearButtonVisible } = props;
    return (React.createElement(React.Fragment, null,
        children,
        hasClearButton && isClearButtonVisible && (React.createElement(StyledClearButtonWrapper, { className: "clear-button-wrapper" },
            React.createElement(StyledClearButton, { appearance: appearance, "aria-label": clearIconLabel, title: clearIconLabel, onClick: onClear, type: "button", className: "clear-button" },
                React.createElement(icons_core_1.Close, { variant: "default" }))))));
};
exports.TextFieldCleanWrapper = TextFieldCleanWrapper;
exports.TextFieldCleanWrapper.displayName = 'TextFieldCleanWrapper';
